import React, { Component } from "react";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import { deleteRequest } from "../../api/ApiService";
import { logError } from "../../services/utils";
import { decrementUnacceptedDecisions } from "../../api/SubmitDecisions";
import WarningAlert from "../../components/alerts/warning";

export default class ModalConfirmProductDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrorModal: false,
      deletingProduct: false,
      product: props.product,
      showAlert: false
    };
    this.onShowDeleteProductModal = this.onShowDeleteProductModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
  }

  showAlert = () => {
    this.setState({
      showAlert: true
    });
  };

  hideAlert = () => {
    this.setState({
      showAlert: false
    });
  };

  deleteProduct() {
    this.setState({
      deletingProduct: true
    });

    const productId = this.state.product.id;
    const url = `${process.env.REACT_APP_API_URL}team/products/${productId}/`;

    return deleteRequest(url)
      .then(res => {
        this.setState({
          deletingProduct: false
        });

        this.props.showSuccessMessage(`Product ${this.props.product.name} was successfully deleted`);
        decrementUnacceptedDecisions("development");
        this.props.reloadProducts();
        this.props.getSubmissionData();
        return null;
      })
      .catch(err => {
        this.setState({
          deletingProduct: false,
        });

        this.props.setErrorMessage('You cannot modify this product', 'To delete a product, operations need to cancel the production of this product first. Please follow up with Operations.');
        logError(err, "ModalConfirmProductDelete", "deleteProduct");
      });
  }

  closeErrorModal() {
    this.setState({
      showErrorModal: false
    });
  }

  onShowDeleteProductModal() {
    const { product } = this.state;
    const { product_manufactures } = this.props;
    const object = product_manufactures.find(i => i.product === product.id);

    this.setState({
      showAlert: false
    });

    if (this.props.hasAccess === false) {
      this.props.showRoleAlert();
    } else if (object) {
      this.props.showEditAlert();
    } else {
      this.deleteProduct();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.product !== nextProps.product) {
      this.setState({
        product: nextProps.product
      });
    }
  }

  render() {
    if (this.state.showErrorModal) {
      return (
        <div className="inline-block">
          <Modal show={this.state.showErrorModal} id="error-modal-dialog">
            <Modal.Header>
              <Modal.Title>
                <div className="alert alert-danger" role="alert">
                  Error
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p>
                Cannot delete product <b>{this.props.product.name}</b>
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button className="btn btn-save" onClick={this.closeErrorModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }

    if (this.state.deletingProduct) {
      return (
        <div className="inline-block">
          <button
            id="delete-product-button"
            type="button"
            onClick={this.onShowDeleteProductModal}
          >
            <svg viewBox="0 0 774.266 774.266">
              <g>
                <path d="M640.35,91.169H536.971V23.991C536.971,10.469,526.064,0,512.543,0c-1.312,0-2.187,0.438-2.614,0.875    C509.491,0.438,508.616,0,508.179,0H265.212h-1.74h-1.75c-13.521,0-23.99,10.469-23.99,23.991v67.179H133.916    c-29.667,0-52.783,23.116-52.783,52.783v38.387v47.981h45.803v491.6c0,29.668,22.679,52.346,52.346,52.346h415.703    c29.667,0,52.782-22.678,52.782-52.346v-491.6h45.366v-47.981v-38.387C693.133,114.286,670.008,91.169,640.35,91.169z     M285.713,47.981h202.84v43.188h-202.84V47.981z M599.349,721.922c0,3.061-1.312,4.363-4.364,4.363H179.282    c-3.052,0-4.364-1.303-4.364-4.363V230.32h424.431V721.922z M644.715,182.339H129.551v-38.387c0-3.053,1.312-4.802,4.364-4.802    H640.35c3.053,0,4.365,1.749,4.365,4.802V182.339z" />
                <rect x="475.031" y="286.593" width="48.418" height="396.942" />
                <rect x="363.361" y="286.593" width="48.418" height="396.942" />
                <rect x="251.69" y="286.593" width="48.418" height="396.942" />
              </g>
            </svg>
          </button>
        </div>
      );
    }

    return (
      <div className="inline-block">
        {this.state.showAlert && (
          <WarningAlert
            title="ARE YOU SURE?"
            message="Deleting a product cannot be undone"
            onCancel={this.hideAlert}
            onSuccess={this.onShowDeleteProductModal}
          />
        )}
        <button
          id="delete-product-button"
          type="button"
          onClick={this.showAlert}
        >
          <svg viewBox="0 0 774.266 774.266">
            <g>
              <path d="M640.35,91.169H536.971V23.991C536.971,10.469,526.064,0,512.543,0c-1.312,0-2.187,0.438-2.614,0.875    C509.491,0.438,508.616,0,508.179,0H265.212h-1.74h-1.75c-13.521,0-23.99,10.469-23.99,23.991v67.179H133.916    c-29.667,0-52.783,23.116-52.783,52.783v38.387v47.981h45.803v491.6c0,29.668,22.679,52.346,52.346,52.346h415.703    c29.667,0,52.782-22.678,52.782-52.346v-491.6h45.366v-47.981v-38.387C693.133,114.286,670.008,91.169,640.35,91.169z     M285.713,47.981h202.84v43.188h-202.84V47.981z M599.349,721.922c0,3.061-1.312,4.363-4.364,4.363H179.282    c-3.052,0-4.364-1.303-4.364-4.363V230.32h424.431V721.922z M644.715,182.339H129.551v-38.387c0-3.053,1.312-4.802,4.364-4.802    H640.35c3.053,0,4.365,1.749,4.365,4.802V182.339z" />
              <rect x="475.031" y="286.593" width="48.418" height="396.942" />
              <rect x="363.361" y="286.593" width="48.418" height="396.942" />
              <rect x="251.69" y="286.593" width="48.418" height="396.942" />
            </g>
          </svg>
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modal/ModalConfirmProductDelete.js